import {
  adaptCourseToApi,
  adaptCourseToStore,
  adaptCoursesToStore,
} from './adapters/courseAdapter'

import { CONTENT } from '@/services/axios.config'
import { buildHeaders } from './utils/build_headers'
import buildParamList from './utils/build_params'
import { buildServices } from './utils/build_services'
import isEmpty from 'lodash.isempty'
import omitBy from 'lodash.omitby'

const services = [
  {
    name: 'listCourses',
    method: 'get',
    url: (params) => `/courses${buildParamList(omitBy(params, isEmpty))}`,
    resolver: adaptCoursesToStore,
  },
  {
    name: 'getCoursesWithoutAdapter',
    method: 'get',
    url: (params) => `/courses${buildParamList(omitBy(params, isEmpty))}`,
  },
  {
    name: 'getCourse',
    method: 'get',
    url: (params) => `/courses/${params.courseId}`,
    resolver: adaptCourseToStore
  },
  {
    name: 'createCourse',
    method: 'post',
    url: () => `/courses`,
    data: (params) => {
      return adaptCourseToApi(params)
    },
    resolver: adaptCourseToStore
  },
  {
    name: 'editCourse',
    method: 'put',
    url: (params) => `/courses/${params.courseId}`,
    data: (params) => {
      return adaptCourseToApi(params)
    },
    resolver: adaptCourseToStore
  },
  {
    name: 'uploadFile',
    method: 'post',
    url: (params) => `/courses/${params.courseId}/csv-import?company=${params.company}`,
    headersFactory: buildHeaders({
      'Content-Type': undefined
    }),
    data: (params) => {
      return params.file
    }
  },{
    name: 'getFile',
    method: 'get',
    url: (params) => `/courses/${params.courseId}/files/${params.fileId}`
  }, {
    name: 'createFile',
    method: 'post',
    url: (params) => `/courses/${params.courseId}/files`,
    data: (params) => {
      return {
        name: params.file.name,
        url: params.file.url
      }
    }
  }, {
    name: 'editFile',
    method: 'put',
    url: (params) => `/courses/${params.courseId}/files/${params.file.id}`,
    data: (params) => {
      return {
        name: params.file.name,
        url: params.file.url
      }
    }
  }, {
    name: 'deleteFile',
    method: 'delete',
    url: (params) => `/courses/${params.courseId}/files/${params.file.id}`
  }
]

export const {
  getCourse,
  listCourses,
  createCourse,
  editCourse,
  uploadFile,
  getFile,
  createFile,
  editFile,
  deleteFile,
  getCoursesWithoutAdapter,
} = buildServices(CONTENT, services)
